<template>
  <SettingsPageLayout>
    <DetailForm
      title="Profile"
      description="Here you can edit profile information of your Company that are automatically syndicated to our job posting boards. Be sure to use your latest and greatest company logo etc."
      action="Save"
      @handleAction="updateTeam"
      hidecancel="true"
      v-if="loaded"
    >
      <TextInput
        label="Company Name"
        placeholder="Humaniz"
        :modelValue="team.company"
        @update:modelValue="value => (team.company = value)"
      />
      <TextInput
        label="Email Reply-To"
        placeholder="recruiting@brokerage.com"
        :modelValue="team.replyTo"
        @update:modelValue="value => (team.replyTo = value)"
      />
      <FileInput
        label="Company Logo"
        limits="any Image"
        :imageholder="team.companyLogo"
        :modelValue="team.companyLogoFile"
        accept="image/*"
        @update:modelValue="team.companyLogoFile = $event"
      />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  data() {
    return {
      team: {
        id: '',
        company: '',
        replyTo: '',
        companyLogo: '',
        companyLogoFile: null,
      },
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/teams/1`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.team.id = data.record.id;
          self.team.company = data.record.company;
          self.team.replyTo = data.record.email_reply_to;
          self.team.companyLogo = data.record.logo;
          self.loaded = true;
        });
    },
    updateTeam() {
      const self = this;
      let formData = new FormData();
      formData.append('company', self.team.company);
      formData.append('email_reply_to', self.team.replyTo);
      self.team.companyLogoFile ? formData.append('company_logo', self.team.companyLogoFile) : null;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/teams/${self.team.id}`, {
        method: 'PUT',
        body: formData,
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          self.getTeam();
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Profile updated',
              alertDescription:
                'Your company settings were successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Profile update error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
